import Alpine from "alpinejs"
import components from "./components"

console.time('init');

for (let [name, component] of Object.entries(components)) {
    Alpine.data(name, component);
}

window.Alpine = Alpine;
Alpine.start();

console.timeEnd('init');
